// extracted by mini-css-extract-plugin
module.exports = {"tabs":"User_tabs__3kO-q","tab":"User_tab__1HqJv"};